import { request, RequestOptions } from '@nextgen-web-framework/core';
import { HandleRequestOptions, SopApiName, SopErrorCodes } from '../types';
import { ErrorResponse, subscriptionApi } from '../services';

export type ErrorAPI = {
  responseBody: ErrorResponse;
  message: string;
  responseBodyArg: ErrorResponse;
};

export async function requestWithVersionFix<T>(
  requestOptions: RequestOptions,
  handleOptions: HandleRequestOptions,
): Promise<T> {
  const { skipIdempotency, additionInfo } = handleOptions;
  return await request<T>(requestOptions, { skipIdempotency }).catch(async (e: ErrorAPI) => {
    if (e.responseBody?.code === SopErrorCodes.VERSION_MISMATCH && additionInfo) {
      const getLatestVersion = await fetchLatestVersion(additionInfo.id, additionInfo.apiForLatestVersion);
      (requestOptions.body as unknown as { version: number }).version = getLatestVersion;
      return request<T>(requestOptions, { skipIdempotency });
    }
    throw e;
  });
}

const fetchLatestVersion = async (id: string, apiForLatestVersion?: SopApiName) => {
  switch (apiForLatestVersion) {
    case SopApiName.SOP: {
      const subscrition = await subscriptionApi.getSubscriptionById({
        subscriptionId: id,
      });
      return subscrition.version;
    }
    case SopApiName.SOP_PROFILE: {
      const profile = await subscriptionApi.getSubscriptionProfile({
        profileId: id,
      });
      return profile.version;
    }
    case SopApiName.SOP_ELEMENT:
    default:
      return 0;
  }
};
